export const customViewsReducer = (state, action) => {
  switch (action.type) {
    case 'setViews': {
      return {
        ...state,
        views: action.views
      };
    }
    case 'createView': {
      return {
        ...state,
        activeViewId: action.id,
        newViewLabel: '',
        views: {
          ...state.views,
          [action.id]: { label: state.newViewLabel?.trim(), value: action.value }
        }
      };
    }

    case 'deleteView': {
      const views = Object.fromEntries(Object.entries(state.views).filter(([id]) => id !== action.id));

      let activeViewId;
      if (state.activeViewId !== action.id) {
        activeViewId = state.activeViewId;
      } else {
        activeViewId = null;
      }

      return {
        ...state,
        views,
        activeViewId
      };
    }

    case 'setActiveView': {
      return {
        ...state,
        activeViewId: action.id,
        isMenuOpened: false
      };
    }

    case 'setNewViewLabel': {
      return {
        ...state,
        newViewLabel: action.label
      };
    }

    case 'togglePopper': {
      return {
        ...state,
        isMenuOpened: !state.isMenuOpened,
        menuAnchorEl: action.element
      };
    }

    case 'closePopper': {
      return {
        ...state,
        isMenuOpened: false
      };
    }

    default: {
      return state;
    }
  }
};
